var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar-badge",class:[_vm.marginClass, _vm.badgeVariantClass]},[(_vm.isSystem)?_c('span',{attrs:{"aria-label":_vm.systemAriaLabel}},[_vm._v(" 🤖 ")]):_c('span',[_vm._v(" "+_vm._s(_vm.initials)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }